import { render, staticRenderFns } from "./DeleteCompanyServiceModal.vue?vue&type=template&id=5fca91fa&"
import script from "./DeleteCompanyServiceModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteCompanyServiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports